"use strict";Object.defineProperty(exports, "__esModule", {value: true});





var _LS2SNHDMcjs = require('../__chunks/LS2SNHDM.cjs');
require('../__chunks/I4CBIWTX.cjs');






exports.isApple = _LS2SNHDMcjs.isApple; exports.isFirefox = _LS2SNHDMcjs.isFirefox; exports.isMac = _LS2SNHDMcjs.isMac; exports.isSafari = _LS2SNHDMcjs.isSafari; exports.isTouchDevice = _LS2SNHDMcjs.isTouchDevice;
